import { createClient } from '@supabase/supabase-js';
import { env } from './env';

/**
 * One browser client with the public anon key. Owner sessions come from
 * Supabase Auth; the studio an owner may act on is decided by the database
 * (membership check in every owner_* RPC), never by this client.
 */
export const supabase = createClient(env.VITE_SUPABASE_URL || 'http://invalid.local', env.VITE_SUPABASE_ANON_KEY || 'missing', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
    storageKey: 'studio-owner-auth',
  },
});

export function mediaUrl(path: string | null | undefined): string | undefined {
  if (!path) return undefined;
  return supabase.storage.from('studio-media').getPublicUrl(path).data.publicUrl;
}
